import { PostSource, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { postCompositionConfigTicker } from '../../components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';

export const WidgetTicker: Widget = {
    type: 'postsTicker',
    id: 'ticker',
    name: 'Ticker',
    useGlobalTimePeriod: true,
    postRequests: [
        {
            sources: [
                {
                    type: 'posts',
                    // Note: All global variables like reportingEngine, report, and filters
                    // are injected via PostRequest.getRequests()
                    id: new PostSource({
                        pageSize: 50,
                        sorts: [
                            new Sort({
                                order: 'DESC',
                                heading: {
                                    MONITORING_DASHBOARD: 'REACH_COUNT',
                                    LISTENING: 'REACH_COUNT',
                                    INBOUND_MESSAGE: 'INBOUND_COUNT',
                                    PLATFORM: 'TOTAL_ENGAGEMENT',
                                    BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                    CAMPAIGN: 'OUTBOUND_STATUS',
                                    RDB_FIREHOSE: 'SN_CREATED_TIME',
                                    STORY_MESSAGE: 'IMPACT',
                                },
                            }),
                        ],
                        includeComments: false,
                        timePeriod: {
                            key: 'last_7_days',
                        },
                    }) as any,
                    options: {
                        count: 200,
                        imagePreload: true,
                        removeDuplicates: true,
                        shufflePosts: false,
                        removeSensitivePosts: true,
                        includeQuoteTweets: false,
                    },
                },
            ],
            format: {
                type: 'ordered',
                options: {
                    fixedList: 3,
                    loop: true,
                },
            },
        },
    ],
    position: {
        ...DefaultWidgetPosition,
        portrait: {
            top: '25%',
            left: '5%',
            height: '50%',
            width: '90%',
        },
    },
    options: {
        player: {
            playing: true,
            duration: 6,
        },
        postVersion: 2,
        retweetIndicator: {
            enabled: true,
            opacity: 50,
            size: 13,
        },
        nativeStyling: {
            retweetIndicator: true,
        },
        ...postCompositionConfigTicker.a,
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
    label: {
        titleText: 'Ticker',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
    },
};
